export const en = {
    consoleUser: {
        alerts: {
            create: {
                title: "Create Console User",
                text: "Are you sure you want to create <b>%{consoleUser}</b>",
                success: {
                    title: "Console User Created Successfully",
                    text: "<b>%{consoleUser}</b> was created successfully",
                },
                error: {
                    title: "Console User Create Error",
                    text: "Something went wrong. Please try again later",
                }
            },
            delete: {
                title: "Delete Console User",
                text: "Are you sure you want to delete <b>%{consoleUser}</b>",
                success: {
                    title: "Console User Deleted Successfully",
                    text: "You will now be redirected to the console users page",
                },
                error: {
                    title: "Console Delete Error",
                    text: "Something went wrong. Please try again later",
                }
            },
            edit: {
                title: "Edit Console User",
                text: "Are you sure you want to edit <b>%{consoleUser}</b>",
                success: {
                    title: "Console User Edited Successfully",
                    text: "<b>%{consoleUser}</b> was edited successfully",
                },
                error: {
                    title: "Console User Edit Error",
                    text: "Something went wrong. Please try again later",
                }
            }
        },
        list: {
            id: "ID",
            name: "Name",
            username: "Username",
            entity: "Entity",
            maxNumberOfConnections: "Maximum Number of Connections",
            status: "Status",
            numberOfConnections: "Number of Connections",
            parent: "Parent Entity",
            type: "Type",
            lastCommunication: "Last Communication"
        },
        form: {
            headers: {
                create: "Create Console User",
                edit: "Edit Console User",
                view: "View Console User"
            },
            name: {
                label: "Name",
            },
            userName: {
                label: "Username",
                error: "Special characters are not allowed"
            },
            type: {
                label: "Type",
            },
            parent: {
                label: "Parent",
            },
            email: {
                label: "Email",
            },
            entity: {
                label: "Entity",
            },
            status: {
                label: "Status",
                active: "Active",
                inactive: "Inactive"
            },
            password: {
                label: "Password",
                error: "Password Must be Equal",
                passwordError: "Wrong Password Format"
            },
            confirmPassword: {
                label: "Confirm Password",
            },
            consoleSettingsPIN: {
                label: "Console Settings PIN",
                error: "PIN must be 4 numeric characters long"
            },
            maxNumberOfConnections: {
                label: "Maximum Number of Connections",
                error: "Inserted Value must be an Integer"
            },
            numberOfConnections: {
                label: "Number of Connections"
            },
            lastCommunication: {
                label: "Last Communication"
            }
        },
        permissions: {
            CONSOLE_USER: "Console Users",
            CREATE_CONSOLE_USER: "Create Console User",
            READ_CONSOLE_USER: "Read Console Users",
            UPDATE_CONSOLE_USER: "Update Console Users",
            DELETE_CONSOLE_USER:"Delete Console Users"
        }
    }
};